import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import ptBR from "./locales/pt-BR.json";
import en from "./locales/en.json";

const resources = {
  "pt-BR": { translation: ptBR },
  en: { translation: en },
};

function detectLanguage(): "pt-BR" | "en" {
  if (typeof navigator === "undefined") {
    return "pt-BR";
  }
  const browserLang = navigator.language;

  if (browserLang.startsWith("en")) {
    console.log(`Detected browser language: ${browserLang}, using English translations.`);
    return "en";
  }

  return "pt-BR";
}

const isDev = process.env.NODE_ENV === "development";
i18n.use(initReactI18next).init({
  resources,
  lng: isDev ? "pt-BR" : detectLanguage(),
  fallbackLng: "pt-BR",
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
